import { useState, useCallback } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import { Preloader } from "@/components/Preloader";
import { Cursor } from "@/components/bits/Cursor";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Manifesto } from "@/components/Manifesto";
import { CaseStudies } from "@/components/CaseStudies";
import { Works } from "@/components/Works";
import { Playground } from "@/components/Playground";
import { Roles } from "@/components/Roles";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { VideoModal } from "@/components/VideoModal";

function App() {
  useLenis();
  const [ready, setReady] = useState(false);
  const [video, setVideo] = useState(null);
  const onDone = useCallback(() => setReady(true), []);
  const closeVideo = useCallback(() => setVideo(null), []);

  return (
    <div className="App paper-grid grain">
      <Preloader onDone={onDone} />
      <Cursor />
      <Nav play={ready} />
      <main>
        <Hero play={ready} />
        <Marquee />
        <About />
        <Manifesto />
        <CaseStudies onOpen={setVideo} />
        <Works onOpen={setVideo} />
        <Playground />
        <Roles />
        <Contact />
      </main>
      <Footer />
      <VideoModal video={video} onClose={closeVideo} />
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#fff", border: "1.5px solid #16150f", boxShadow: "3px 3px 0 #16150f", fontFamily: "Instrument Sans, sans-serif", borderRadius: 6 } }} />
    </div>
  );
}

export default App;
